var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/030abb4240ccfc1b63e34632a9d6ac51.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c5c36be6b3582f9835c5648086fa18b8.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0148ce2c7c1cc963bad978d6afb435e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    